class PackageCard extends HTMLElement {
    constructor() {
        super();
        
        this.productID = 45742514503866;

    }

    async connectedCallback() {
        this.checkbox = this.querySelector('.package-card__checkbox-input');
        if(!this.checkbox) return;

        this.checkbox.addEventListener('change', () => {
            const state = this.checkbox.checked;
            
            if(state) {
                const cartURL = window.Shopify.routes.root + "cart/add.js";
                const formData = { 'items': [{ 'id': this.productID, 'quantity': 1} ]};
                const requestConfig = { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}

                fetch(cartURL, requestConfig)
                .then(req => req.json())
                .then(res => console.log(res))
                .catch(error => console.log(error))
                .finally(() => {
                    this.updateCartQuantity();
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: "package-card" });
                });
            } else {
                this.removeItem();
            }
        });
    }

    async removeItem() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            console.log("CART:", cart);

            const item = cart.items.find(
                (i) => i.variant_id === this.productID
            );

            if (!item) return;

            const cartURL = window.Shopify.routes.root + "cart/change.js";

            const formData = {
                id: item.key, // IMPORTANT: safest identifier
                quantity: 0
            };

            const requestConfig = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            };

            fetch(cartURL, requestConfig)
            .then((req) => req.json())
            .then((res) => console.log(res))
            .catch((error) => console.log(error))
            .finally(() => {
                this.updateCartQuantity();
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "package-card" });
            });

        } catch (error) {
            console.log("REMOVE ERROR:", error);
        }
    }

    async updateCartQuantity() {
        const headerQuantity = document.querySelector('#cart-icon-bubble .wt-header__panel__counter');
        const drawerQuantity = document.querySelector('#cart-drawer-quantity-bubble');

        const res = await fetch('/cart.js');
        const cart = await res.json();

        if(headerQuantity) headerQuantity.innerHTML = cart.item_count;
        if(drawerQuantity) drawerQuantity.innerHTML = `(${cart.item_count})`;

    }

}

if(!customElements.get('package-card')) customElements.define('package-card', PackageCard);